<script lang="ts" setup>
import { ref, computed } from 'vue';
import { normalizeClasses } from '@/helpers/Utils';
import IdeoPopover from '@/components/ideo/popover/IdeoPopover.vue';

defineOptions({
    name: 'confirmation'
});

const props = defineProps({
  "value": null,
  "target": null,
  "message": null,
  "placement": { default: 'left' },
  "id": { default: null },
  "wrapperClass": { default: '' },
  "actionClass": { default: '' }
});

const emit = defineEmits(["confirm", "cancel"]);

const popover = ref<IdeoPopover>(null);

const open = (target?: HTMLElement): void =>
{
    popover.value.open(target);
};

const close = (): void =>
{
    popover.value.close();
};

const confirm = (): void =>
{
    close();
    emit('confirm', props.value);
};

const cancel = (): void =>
{
    close();
};

const wrapperClasses = computed(() => ({
    'd-flex align-items-center': true,
    ...normalizeClasses(props.wrapperClass)
}));

const actionClasses = computed(() => ({
    'ms-auto': true,
    ...normalizeClasses(props.actionClass)
}));

defineExpose({
    open
});
</script>

<template>
    <ideo-popover ref="popover" class="popover" :id="id" :target="target" :placement="placement" triggers="blur click">
        <div :class="wrapperClasses">
            <b class="me-2" v-html="message.replaceAll('\n', '<br>')"></b>
            <div :class="actionClasses">
                <ideo-button-group class="rounded overflow-hidden" size="sm">
                    <ideo-button variant="danger" @mousedown.stop.prevent="confirm">
                        {{ $t('[[[Tak]]]') }}
                    </ideo-button>
                    <ideo-button variant="secondary" @mousedown.stop.prevent="cancel">
                        {{ $t('[[[Nie]]]') }}
                    </ideo-button>
                </ideo-button-group>
            </div>
        </div>
    </ideo-popover>
</template>

<style lang="scss" scoped>
.popover {
    border-radius: 4px;
    min-width: 250px;
    box-shadow: 0px 3px 6px rgba(75, 81, 91, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.15);
}
</style>
